module.exports = __webpack_public_path__ + "static/media/profile-settings.04e75657.png";